import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=1942f5f1&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=1942f5f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942f5f1",
  null
  
)

export default component.exports